// 只记本页哪些已落库消息没播完，不保存正文、Token或个人资料；按查看者与会话隔离。
const interrupted = new Map();
export const playbackScope = (viewerId, conversationId) =>
  viewerId && conversationId ? `${viewerId}:${conversationId}` : '';

/** 有界保留中断消息ID；完成播放后删除，历史完整消息不会反复打字。 */
export function rememberInterruptedPlayback(scope, messageId) {
  if (!scope || !messageId) return;
  const key = `${scope}:${messageId}`;
  interrupted.delete(key);
  interrupted.set(key, true);
  if (interrupted.size > 256) interrupted.delete(interrupted.keys().next().value);
}
export const shouldReplayInterruptedMessage = (scope, messageId) => interrupted.has(`${scope}:${messageId}`);
export const completeInterruptedPlayback = (scope, messageId) => interrupted.delete(`${scope}:${messageId}`);
